import React, { useEffect } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography, Box } from "@mui/material";
import { HiCheck } from "react-icons/hi";
import { BsThreeDots } from "react-icons/bs";
import { setPageTitle } from "../slice";
import Candidates from "../components/candidates/Candidates";
import SearchFilters from "../components/candidates/SearchFilters";

function SearchAndCandidates() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { data } = useSelector((state) => state.UserCurrentState);

  let currentLocation = location.pathname.split("/")[2];

  const handleSearchAccessibility = () => {
    const accessCodes = [8, 65, 70, 50];
    return accessCodes.includes(parseInt(data?.code));
  };

  const steps = [
    {
      route: "search",
      label: "جستجو",
      disabled: false,
      status: "",
      errors: [],
      component: SearchFilters,
    },
    {
      route: "candidate",
      label: "کاندیدهای همسانی",
      disabled: false,
      status: "",
      errors: [],
      component: Candidates,
    },
  ];

  useEffect(() => {
    dispatch(setPageTitle("جستجو و کاندیدها"));
  }, [dispatch]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="row-reverse"
        alignItems="center"
        justifyContent="center"
        pb={2}
      >
        {steps.map(({ label, route, status }) => {
          return (
            <Box display="inline">
              <Button
                key={route}
                style={{ display: "inline-block", minWidth: "140px", flex: 1 }}
                onClick={() => navigate(`${route}`)}
              >
                <Box sx={{ textAlign: "center", display: "inline" }}>
                  <span
                    style={{
                      display: "flex",
                      borderRadius: "50%",
                      backgroundColor: currentLocation === route ? "#0EE8B6" : "#f1f0f0",
                      width: "22px",
                      height: "22px",
                      margin: "0.4rem auto 1rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {currentLocation === route && (
                      <BsThreeDots color="#FFFFFF" fontSize="1.1rem" letterSpacing="0px" />
                    )}
                    {status === "complete" && <HiCheck color="#FFFFFF" fontSize="1.1rem" />}
                  </span>
                  <Typography style={{ color: "#797979", textAlign: "center" }}>{label}</Typography>
                </Box>
              </Button>
            </Box>
          );
        })}
      </Box>
      {handleSearchAccessibility() && (
        <Routes>
          {steps.map((item) => (
            <Route key={item.route} path={`${item.route}`} element={<item.component />} />
          ))}
        </Routes>
      )}
    </>
  );
}

export default SearchAndCandidates;
